<template>
  <rv-step-sidebar-content
    data-automation="step-password-saved__content"
    :title="$t('members.titles.passwordSaved')"
  >
    <div class="step-password-saved q-mx-lg">
      <div class="flex justify-center">
        <q-icon
          class="step-password-saved__icon flex justify-center q-mb-sm"
          data-automation="step-password-saved__icon"
          name="img:/rvai-base/robot-generate-link.svg"
          size="7rem"
        />
      </div>
      <div data-automation="step-password-saved__content__label">
        {{ $t('members.titles.passwordSuccessfullyChanged') }}
      </div>
    </div>

    <template #actions>
      <div class="full-width flex">
        <rv-button
          class="full-width"
          color="primary"
          data-automation="step-password-saved__back-to-profile"
          :label="$t('members.actions.backToProfile')"
          @click="onReset"
        />
      </div>
    </template>
  </rv-step-sidebar-content>
</template>

<script lang="ts" setup>
import { useStepSidebar } from '@robovision/rvai-base'


const { onReset } = useStepSidebar()

</script>

<style lang="sass" scoped>
.step-password-saved
  &__icon
    margin-top: 38px
    margin-bottom: 40px
</style>
